import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import EntityFormPage, { EntityForm } from '@entity/EntityForm/EntityForm';
import getGraphqlData from '@boilerplate/lib/getGraphqlData';
import { BaseFormInsertProps } from '@boilerplate/types/entity';
import { addEntityToRelatedDataOptions } from '@boilerplate/lib/relatedDataToOptions';
import Notistack from '@/lib/notistack';
import { catchGraphQlError } from '@/lib/catchError';

import DaysOffEntity from '@/entities/daysOff';
  import UserEntity from '@/entities/user';

function DaysOffBaseInsertForm({ formOnly = false, onClose, Entity = DaysOffEntity, ...props }: BaseFormInsertProps<typeof DaysOffEntity.model>) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [createMutation, { loading }] = DaysOffEntity.model.useCreate();

  const Component = formOnly ? EntityForm : EntityFormPage;

  const relationsOptionsQuery = DaysOffEntity.model.useRelationsOptions({
    variables: {
          withUsers: true,
    }
  });

  const relationsOptions = useMemo(
    () =>
      addEntityToRelatedDataOptions(relationsOptionsQuery, [
              UserEntity,
      ]),
    [relationsOptionsQuery]
  );

  const handleSubmit = (data) => {
    data.variables = getGraphqlData(Entity, data.variables, 'insert');

    createMutation(data)
      .then((result) => {
        Notistack.toast(t('crud:createdItem', { item: t('entities:daysOff') }), { variant: 'success' });


        if (!formOnly) {
          navigate(-1);
        }

        return onClose?.(result.data?.createDaysOff);
      })
      .catch(catchGraphQlError);
  };

  if (relationsOptionsQuery.loading) {
    return <CircularProgress />;
  }

  return (
    <Component
      {...props}
      type="insert"
      Entity={Entity}
      loading={loading}
      handleSubmit={handleSubmit}
      relationsOptions={relationsOptions}
    />
  );
}

export default DaysOffBaseInsertForm;
